import gql from 'graphql-tag';

const getPaymentInvoiceQuery = gql`
  query GetPaymentInvoice(
    $videoId: String
    $organisationId: String!
    $orderId: String
    $isUrl: Boolean
  ) {
    getPaymentInvoice(
      videoId: $videoId
      organisationId: $organisationId
      orderId: $orderId
      isUrl: $isUrl
    ) {
      invoiceUrl
      invoiceId
      orderId
      refundedAt
      createdAt
    }
  }
`;

const getPaymentInvoice = (organisationId: string) => ({
  query: getPaymentInvoiceQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({
    invoiceId,
    orderId,
    isUrl = true
  }: {
    invoiceId: string;
    orderId: string;
    isUrl?: boolean;
  }) => ({
    invoiceId,
    organisationId,
    orderId,
    isUrl
  })
});

export default getPaymentInvoice;
